const GLOBAL = {
  gm: {
    //国免
    logo: "guomian",
    appName: "GM国免跨境",
    appTitle: "国免跨境",
    normalName: "国免",
    wechatName: "国免（海南）",
    companyName: "海港时代（海南）国际贸易有限公司",
    tel: "0898-68529737",
    email: "guomianidf@163.com",
    record: "琼ICP备2025050337号",
    address:
      "海南省海口市美兰区<br>海府街道五指山路17号<br>锦江都城大厦观光梯三楼国免跨境",
    desc: "国免集团总部设立于香港",
    content:
      "团队分布中韩两地，由自2012年起专业从事韩免直采的团队，平移资源，常驻海南海口，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的， 集韩国免税店货源采购与 国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提 供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口 岸对接等服务",
    shop_id: "-1",
    od_id: "1",
    companyId: "A02A02",
  },
  cm: {
    //川免
    logo: "chuanmian",
    appName: "川免乐购",
    appTitle: "川免",
    normalName: "川免",
    wechatName: "川免科技",
    companyName: "川免集团公司",
    tel: "400-7766-111",
    email: "cmliliang202188@163.com",
    record: "蜀ICP备2021010831号",
    address: "四川省成都市温江区凤凰汇邻里A1电梯4楼",
    desc: "总部设立于中国成都",
    content:
      "核心团队分布中韩两地，自2012年起，由专业从事韩免直采的团队，平移资源，常驻海南海口，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“川免乐购”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者，真正的做到了规范这个行业的“真大牌、真品质、真免税、真优惠”四真保障去服务于消费者。公司以创新的商业模式进行市场推广，返利消费者的同时也让消费者成为平台的忠实推广者，并获得更多的实际权益。",
  },
  am: {
    //安免
    logo: "anmian",
    appName: "安免跨境商城",
    appTitle: "安免",
    normalName: "安免",
    wechatName: "安免跨境商城",
    tel: "0790-6665078",
    email: "lxa18179051130@163.com",
    companyName: "新余市德元信息咨询管理有限责任公司",
    record: "赣ICP备2021004551号-1",
    address: "江西省新余市渝水区劳动北路万宝国际大厦1701",
    desc: "总部设立于中国江西新余",
    content:
      "核心团队分布中韩两地，由专业从事韩免直采的团队，平移资源，总部常驻海南海口，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“安免商城”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者。",
  },
  hdm: {
    //海岛免
    logo: "haidaomian",
    appName: "海岛免跨境商城",
    appTitle: "海岛免",
    normalName: "海岛免",
    wechatName: "海岛免",
    tel: "13976740835",
    email: "hdm00441316@163.com",
    companyName: "海岛免（海南）跨境电商有限公司",
    record: "琼ICP备2021003702号",
    address: "海南省海口市琼山区国兴大道富力首府天盈广场601",
    desc: "总部设立于中国海南海口",
    content:
      "核心团队分布中韩两地，由专业从事韩免直采的团队，平移资源，常驻海南海口，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“海岛免”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者。",
  },
  bm: {
    //保免
    logo: "baomian",
    appName: "保免DFO跨境商城",
    appTitle: "保免",
    normalName: "保免",
    wechatName: "保免",
    tel: "400-866-0593",
    email: "18650557588@qq.com",
    companyName: "保免（海南）科技有限公司",
    record: "琼ICP备2021008695号-1",
    address: "福建省宁德市蕉城区天湖东路2号宝信行政公馆22幢705",
    desc: "总部设立于中国福建省宁德市",
    content:
      "保免DFO主体天耀企业于2019年海淘项目立项至今积累筛选出许多优质供应链渠道，2020年正式命名保免DFO（跨境免税线上电商平台）2020年保免DFO项目组团队组建，进行各项综合测试、供应链筛选。2021年保免DFO自建海南保税仓、公众号、小程序、APP正式上线。",
  },
  ym: {
    //友免
    logo: "youmian",
    appName: "YouM友免跨境购",
    appTitle: "友免",
    normalName: "友免",
    wechatName: "友免",
    tel: "400-1556-880",
    email: "3559607890@qq.com",
    companyName: "福建省广联信息科技有限公司",
    record: "闽ICP备2021008766号",
    address: "福建省漳州市龙文区九龙大道万达写字楼A座810号",
    desc: "广联友免设立于福建漳州",
    content:
      "核心团队分布中韩两地，由专业从事韩免直采的团队，平移资源，常驻福建漳州，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“YouM友免跨境购”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者。",
  },
  hma: {
    //惠免
    logo: "huimianA",
    appName: "甄免跨境",
    appTitle: "甄免",
    normalName: "甄免",
    wechatName: "甄免",
    tel: "400-6611-161",
    email: "366272592@qq.com",
    companyName: "河南乐免电子科技有限公司",
    record: "豫ICP备2021017793号-1",
    address: "郑州市金水区东风路街道东风路142号瀚海海尚A座19层1906号",
    desc: "甄免跨境电商有限公司设立于河南郑州",
    content:
      "核心团队分布中韩两地，由专业从事韩免直采的团队，平移资源，常驻郑州，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“甄免跨境”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者。",
  },
  bdf: {
    //宝洛尔
    logo: "baoluoer",
    appName: "BOLOR宝洛尔",
    appTitle: "宝洛尔",
    normalName: "宝洛尔",
    wechatName: "宝洛尔",
    tel: "0471-5611277",
    email: "BOLOR451908658@163.com",
    companyName: "内蒙古宝洛尔跨境商贸有限公司",
    record: "蒙ICP备2021002302号-1",
    address: "内蒙古自治区呼和浩特市回民区中山西路天元奥莱活力港B1层01区",
    desc: "内蒙古宝洛尔跨境商贸有限公司设立于内蒙古",
    content:
      "（以下简称“宝洛尔”，宝洛尔蒙文意“水晶”或“清澈的小溪”），是一家紧跟国家政策从事跨境电商零售进口及一般进出口贸易的公司。宝洛尔依托国家跨境电商政策优势，以呼和浩特综合保税区为核心大力发展跨境电商+线下体验的新业态。该业态以线下实物展示体验、线上下单购物为主，给跨境消费者近距离感受体验全球海量商品的机会，结合直面交流专业导购优势，将海外购物场景还原到消费者身边；海关全程监管+跨境电商零售进口税收政策让消费者能够切身体什么是真正的货真价实；以小程序扫描商品条形码，消费者即可自主完成下单支付，方便快捷；同城保税仓快速发货，让消费者能够享受到隔日达的高效配送体验。",
  },
  wdf: {
    //汇免
    logo: "huimianB",
    appName: "汇免跨境",
    appTitle: "汇免",
    normalName: "汇免",
    wechatName: "汇免",
    tel: "0898-66773839",
    email: "huimian2021@163.com",
    companyName: "海南汇免进出口贸易有限公司",
    record: "琼ICP备2021003888号",
    address: "海南省海口市龙华区国贸大道56号北京大厦7层A房",
    desc: "海南汇免进出口贸易有限公司设立于海南海口",
    content:
      "核心团队分布中韩两地，由专业从事韩免直采的团队，平移资源，常驻海南，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“汇免易购”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者。",
  },
  gl: {
    //汇免
    logo: "51jingxuan",
    appName: "国免优选（海南）",
    appTitle: "51鲸选",
    normalName: "51鲸选",
    wechatName: "51鲸选",
    tel: "18065236111",
    email: "2942142268@qq.com",
    companyName: "国免优选（海南）电子商务有限公司",
    record: "琼ICP备2021004949号-1",
    address: "海南省海口市保税区海口综合保税区联检大楼四楼",
    desc: "51鲸选设立于海南海口",
    content:
      "核心团队分布中韩两地，由专业从事韩免直采的团队，平移资源，常驻福建漳州，致力于打造跨境电商、品牌运营（可授权）、电子商务等为一体的，集韩国免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证、跨境结算认证、实名购买保障、跟踪售后服务及交易平台搭建、跨境支付、仓储物流、海关口岸对接等服务。集团旗下跨境免税平台“国际免选”主营产品以国际大牌时尚轻奢、美容彩妆、个人护理、营养保健、钟表首饰、护肤、服装、母婴用品等为主，通过国家大力扶持下的新型跨境免税商业模式，将国际大牌产品百分之百确保正品的前提下又以最低的价格提供给国内消费者。",
  },
  yim: {
    //艺免
    logo: "yimian",
    appName: "艺免跨境",
    appTitle: "艺免跨境",
    normalName: "艺免跨境",
    wechatName: "艺免跨境",
    tel: "18078993526",
    email: "1021982024@qq.com",
    companyName: "海南艺免科技有限公司",
    record: "琼ICP备2021008715号-1",
    address: "海南省洋浦经济开发区新英湾区盐田路政务中心大楼东北24-6-107",
    desc: "艺免科技有限公司",
    content:
      "成立于2020年8月，自成立以来，致力于成为海南自贸港跨境电商的先行者，依照跨境商品的要求，艺免所有销售商品都严格把关链路清晰，确保每项进口交易数据可均可跟踪，每件进口商品都可追溯。打造开放一体化的供应链管理及物流配送服务，保证每一个环节都 可以让顾客放心。",
  },
  guanm: {
    //冠免跨境
    logo: "guanmian",
    appName: "冠免跨境",
    appTitle: "冠免跨境",
    normalName: "冠免跨境",
    wechatName: "冠免跨境",
    tel: "136975439681",
    email: "505643431@qq.com",
    companyName: "冠免（海南）科技集团有限公司",
    record: "琼ICP备2022001516号",
    address:
      "海南省海口市保税区海口综合保税区海控保物流园A3层海口国免中心仓A1-301-16A",
    desc: "冠免科技集团有限公司",
    content:
      "冠免（海南）科技集团有限公司（简称：冠免集团）成立于2022年1月，总部设在中国自由贸易港——海南，是跨境免税行业标杆企业“国免”剥离出来的平台公司，着力打造线上线下免税店，通过国家扶持下的新型跨境免税全球购的“商业模式”，将国际大牌产品“保真、保质又实惠便捷”地提供国内消费者，以“真大牌、真品质、真免税、真优惠”四真保障去服务国民，勇冠免税奢侈品最高性价比；依托冠免集团旗下供应链公司——冠免（海南）供应链管理有限公司为货源物流提供保障。公司自2012年起专业从事韩免直采业务，平移资源，致力打造海南跨境电商，品牌运营（可授权）商务为一体，集澳美欧、日韩泰、新西兰免税店货源采购与国际跨境免税供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案，面向跨境进口类商家提供境内外主体认证，跨境结算认证，实名购买保障，跟踪售后服务及交易平台搭建，跨境支付，仓储物流、海关口岸对接等服务。国家倡导的数字人民币已在冠免（海南）科技集团有限公司落地使用并支付成功！",
  },
  haitao: {
    //嗨淘全球购
    logo: "haitao",
    appName: "嗨淘全球购",
    appTitle: "嗨淘全球购",
    normalName: "嗨淘全球购",
    wechatName: "嗨淘全球购",
    tel: "13916442349",
    email: "13916442349@139.com",
    companyName: "嗨淘（海南）科技有限公司",
    record: "琼ICP备2022003075",
    address: "海南省海口市美兰区蓝天街道蓝天路37号六层综合办公楼5楼507-29",
    desc: "嗨淘（海南）科技有限公司",
    content:
      "嗨淘（海南）科技有限公司在跨境电商政策红利的支持下应运而生，总部设于上海，运营团队分布全国各地，现包含专业从事直采的团队，平移资源，常驻海南海口的团队，致力于打造跨境电商、品牌运营、电子商务等为一体的，集免税店货源采购与国际跨境免税品供应链的综合型互联网科技服务企业，提供全链路跨境电商行业解决方案。嗨淘科技自成立以来，始终秉承“产品保质、客户至上、服务至上”的企业使命，从未停止进取的脚步。未来，面对快速变化的市场环境带来的挑战，“嗨淘”将抓住机遇，深挖国人消费潜力，积极参与机场和口岸的免税业务，为更多的消费者带来更多高品质的进口产品。",
  },
};

const appType = "gm";

export default {
  GLOBAL: GLOBAL[appType],
};
